import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ConsentsAndDeclarationsPurpose, LegalTextPosition } from '../api/types';

const useConsentsAndDeclarationsOptions = () => {
    const { t } = useTranslation('consentsAndDeclarations');

    return useMemo(() => {
        const purposeOptions = [
            {
                value: ConsentsAndDeclarationsPurpose.Kyc,
                label: t('consentsAndDeclarations:options.purpose.kyc'),
            },
            {
                value: ConsentsAndDeclarationsPurpose.Payment,
                label: t('consentsAndDeclarations:options.purpose.payment'),
            },
            {
                value: ConsentsAndDeclarationsPurpose.Share,
                label: t('consentsAndDeclarations:options.purpose.share'),
            },
        ];

        const legalTextPositionOptions = [
            {
                value: LegalTextPosition.Modal,
                label: t('consentsAndDeclarations:options.legalTextPosition.modal'),
            },
            {
                value: LegalTextPosition.After,
                label: t('consentsAndDeclarations:options.legalTextPosition.after'),
            },
            {
                value: LegalTextPosition.Before,
                label: t('consentsAndDeclarations:options.legalTextPosition.before'),
            },
        ];

        return {
            purposeOptions,
            legalTextPositionOptions,
        };
    }, [t]);
};

export default useConsentsAndDeclarationsOptions;
